export default __webpack_public_path__ + "static/media/attention3.03ee743b.mp3";